import React from 'react';
import { ListingOptimizer } from '../../components/tools/ListingOptimizer';
import { useToolExecution } from '../../hooks/useToolExecution';
import { ToolHeader } from '../../components/ui/ToolHeader';
import { TOOL_COSTS } from '../../constants';

export const ListingTool = () => {
  const { checkCredits, deductCredits, refundCredits } = useToolExecution();

  return (
    <div>
      <ToolHeader 
        title="Listing Optimizer"
        cost={`${TOOL_COSTS.listing} (Text) / ${TOOL_COSTS.video_generation} (Video)`}
        description={
          <>
            <p className="font-bold">Generate optimized listings & videos in one step.</p>
            <p>1. Upload a product image (optional, but required for video).</p>
            <p>2. Enter your current basic title, description, and tags.</p>
            <p>3. Use "Auto-Generate Video" to create a promo video alongside the text analysis.</p>
          </>
        }
      />
      <ListingOptimizer 
        checkCredits={checkCredits}
        onCostIncurred={(cost) => deductCredits(cost, 'Listing')}
        onRefund={refundCredits}
      />
    </div>
  );
};
